<template>
  <div>
    <template v-if="selectedActivities.length">
      <router-link
        v-for="activity in selectedActivities"
        :to="`/meetings/${activity.id}`"
        :key="activity.id"
        :class="$style.activity">
        <CallInfo
          :activity="activity"
          :info="[]"
          :actions="[]"
          :isLink="true"
          :class="$style.callInfo" />
      </router-link>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CallInfo from '@/components/shared/CallInfo/CallInfo'

const { mapState: mapGlobalState } = createNamespacedHelpers('global')

export default {
  components: {
    CallInfo
  },
  props: {
    limit: {
      type: Number,
      default: 10,
      validator: function (value) {
        return value > 0 && value <= 10
      }
    }
  },
  computed: {
    ...mapGlobalState([
      'ongoingActivities'
    ]),
    selectedActivities () {
      return this.ongoingActivities.slice(0, Math.min(this.limit, this.ongoingActivities.length))
    }
  }
}
</script>

<style module>
.activity {
  text-decoration: none;
}

.callInfo {
  background: var(--panel-separator-color);
  border-bottom: 1px solid var(--main-bg-color);
}
</style>



// WEBPACK FOOTER //
// OngoingMeetings.vue?64fb95ec